import { Link, useLocation } from "react-router-dom";
import BookCallButton from "@/components/BookCall";
import { mediaUrl, sz, txt, useContent } from "@/content/ContentContext";
import logoMark from "@/assets/logo-mark.png";

const Header = () => {
  const { pathname } = useLocation();
  const c = useContent();
  const g = c.global;
  const onHome = pathname === "/";

  const navItems = [
    { node: g.nav.home, to: onHome ? "#home" : "/", id: "nav-home", active: onHome },
    { node: g.nav.services, to: "/services", id: "nav-services", active: pathname.startsWith("/services") },
    { node: g.nav.blog, to: "/blog", id: "nav-blog", active: pathname.startsWith("/blog") },
    { node: g.nav.about, to: "/about", id: "nav-about", active: pathname.startsWith("/about") },
    { node: g.nav.contact, to: "/contact", id: "nav-contact", active: pathname.startsWith("/contact") },
  ];

  return (
    <header className="site-header">
      <div className="header-inner">
        <Link to="/" className="brand" data-testid="brand-logo">
          <img
            src={g.logoImage ? mediaUrl(g.logoImage) : logoMark}
            alt="IT Device Services"
            className="brand-logo-img"
          />
          <span className="brand-sub" style={sz(g.brandSub)}>
            {txt(g.brandSub)}
          </span>
        </Link>
        <nav className="main-nav" aria-label="Main navigation">
          {navItems.map((item) => {
            const className = item.active ? "nav-link nav-link-active" : "nav-link";
            if (item.to.startsWith("#")) {
              return (
                <a key={item.id} href={item.to} className={className} style={sz(item.node)} data-testid={item.id}>
                  {txt(item.node)}
                </a>
              );
            }
            return (
              <Link key={item.id} to={item.to} className={className} style={sz(item.node)} data-testid={item.id}>
                {txt(item.node)}
              </Link>
            );
          })}
        </nav>
        <BookCallButton className="btn-dark header-cta" testId="header-cta" />
      </div>
    </header>
  );
};

export default Header;
